import type { RouteRecordRaw } from 'vue-router';

export const leaveApprovalWorkflowRoutes: RouteRecordRaw[] = [
  {
    path: '/leave-management/approval-workflow',
    name: 'LeaveApprovalWorkflow',
    component: () => import('../components/LeaveApprovalWorkflowView.vue'),
    meta: {
      title: 'Leave Approval Workflow',
      requiresAuth: true,
      permissions: ['leave.workflow.view']
    }
  }
];